module.exports = __webpack_public_path__ + "img/1_1-industriale-fabbrica-2.5fb04d81.png";